"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentStatus = exports.PaymentMethodType = exports.PaymentProvider = void 0;
var actions_1 = require("./actions");
var PaymentProvider;
(function (PaymentProvider) {
    PaymentProvider["Stripe"] = "stripe";
    PaymentProvider["Yookassa"] = "yookassa";
    PaymentProvider["Ameriabank"] = "ameriabank";
    PaymentProvider["Tinkoff"] = "tinkoff";
})(PaymentProvider = exports.PaymentProvider || (exports.PaymentProvider = {}));
var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["apple"] = "apple";
    PaymentMethodType["gpay"] = "gpay";
    PaymentMethodType["card"] = "card";
})(PaymentMethodType = exports.PaymentMethodType || (exports.PaymentMethodType = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["pending"] = "pending";
    PaymentStatus["accepted"] = "accepted";
    PaymentStatus["canceled"] = "canceled";
    PaymentStatus["error"] = "error";
})(PaymentStatus = exports.PaymentStatus || (exports.PaymentStatus = {}));
var initState = {
    order_id: null,
    key: '',
    pi_client_secret: '',
    pi_status: '',
    method: '',
    cards: [],
    loading: false,
    status: null,
    confirmed: null,
    pkey: null
};
exports.default = (function (state, action) {
    if (state === void 0) { state = initState; }
    switch (action.type) {
        case actions_1.FETCH_PAYMENT_INTENT_REQUEST:
            return __assign(__assign({}, state), { loading: true });
        case actions_1.FETCH_PAYMENT_INTENT_SUCCESS:
            return __assign(__assign({}, state), { loading: false, order_id: action.data.order_id, pi_client_secret: action.data.client_secret, pi_status: action.data.status, key: action.data.key });
        case actions_1.FETCH_PAYMENT_INTENT_FAILURE:
            return __assign(__assign({}, state), { loading: false });
        case actions_1.PAYMENT_CLEAR:
            return initState;
        case actions_1.PAYMENT_INTENT_CLEAR:
            return __assign(__assign({}, initState), { status: state.status, loading: state.loading, confirmed: state.confirmed });
        case actions_1.CHECK_PAYMENT:
            return __assign(__assign({}, state), { loading: true, status: PaymentStatus.pending, confirmed: null });
        case actions_1.CHECK_PAYMENT_SUCCESS:
            return __assign(__assign({}, state), { loading: false, status: action.data.status, confirmed: true });
        case actions_1.CHECK_PAYMENT_FAIL:
            return __assign(__assign({}, state), { loading: false, status: PaymentStatus.error, confirmed: false });
        default:
            return state;
    }
});
